module.exports = __webpack_public_path__ + "static/media/misc.9da06d13.svg";